import React, { useState, useEffect } from "react";
import { AbsoluteCenter } from "../../AbsoluteCenter";
import { ButtonWithSound } from "../../AudioProvider";
import { useTranslation } from "react-i18next";
import infoIcon from "../../../assets/info.svg";
import { useScreenType } from "../../../hooks/useScreenType";
import dayjs from "dayjs";

const validInvitationTime =
  process.env.REACT_APP_VALID_TOURNAMENT_INVITATION_TIME || 30;

const PopupContainer = ({ children }: { children?: React.ReactNode }) => {
  const screenType = useScreenType();

  return (
    <div className="absolute bg-black-alpha-30 top-0 left-0 right-0 bottom-0 z-50">
      {screenType === "DESKTOP" ? (
        <AbsoluteCenter>{children}</AbsoluteCenter>
      ) : (
        <div className="flex justify-center items-center h-screen">
          {children}
        </div>
      )}
    </div>
  );
};

export const FewInvitePairErrorModal = ({
  onClose,
  requestTime,
}: {
  onClose: () => void;
  requestTime: string;
}) => {
  const { t } = useTranslation();

  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const tick = () => {
      const target = dayjs(requestTime).add(+validInvitationTime, "second");
      const diff = target.diff(dayjs(), "second");

      if (diff > 0) {
        setSeconds(diff);
      } else {
        setSeconds(0);
        onClose();
      }
    };

    tick(); // одразу
    const id = setInterval(tick, 1000);
    return () => clearInterval(id);
  }, [requestTime]);

  return (
    <PopupContainer>
      <div
        style={{
          width: "420px",
          background: "linear-gradient(180deg, #306DAE 0%, #063358 100%)",
          border: "1px solid #1E71D3",
          borderRadius: "20px",
          padding: "40px 32px",
        }}
        className="text-white flex flex-col items-center gap-3"
      >
        <img src={infoIcon} width={50} height={50} alt="Success" />
        <div className="flex flex-col items-center gap-6">
          <div className="flex flex-col items-center gap-1 text-center">
            <p
              style={{
                fontSize: "20px",
                lineHeight: "30px",
                fontWeight: 500,
              }}
            >
              {t("instant_tournament.few_invite_modal.title")}
            </p>
            <p>{t("instant_tournament.few_invite_modal.description")}</p>
            <div
              className="flex justify-center font-semibold"
              style={{ color: "#FFDA33" }}
            >
              {t("seconds_value", { value: seconds })}
            </div>
          </div>
          <ButtonWithSound
            className="btn-green-500 rounded-md shadow-xl text-white w-2/5 py-1 text-sm h-7"
            onClick={onClose}
          >
            {t("instant_tournament.error_join.action")}
          </ButtonWithSound>
        </div>
      </div>
    </PopupContainer>
  );
};
